<template>
  <section class="category-config">
    <SlideTitleSettingsV2 :showImageInputField="false" />
    <section class="category-options-section form-group">
      <label class="label-option">{{ $i18nPresenter.t('Category & options') }}</label>
      <aha-info-box class="mb-2">
        <p>{{ $i18nPresenter.t('Enter options, separated by commas') }}</p>
      </aha-info-box>
      <section class="category-options">
        <CategoryInput
          v-for="(category, index) in categories"
          @remove-category="removeCategory"
          @category-update="updateCategory"
          :removable="removable"
          :id="category.id"
          :category="category"
          :color="categoryColorMap[index]"
          :background-color="categoryBackgroundColorMap[index]"
          :annotation="categoryAnnotationMap[index]"
          :key="category.id"
        />
      </section>
    </section>
    <section
      v-if="!isMaxItems"
      class="button-section form-group"
    >
      <aha-button
        class="w-full"
        @click="addCategory"
      >
        <aha-svg name="add" />
        <span>{{ $i18nPresenter.t('Add Category') }}</span>
      </aha-button>
    </section>
    <Settings isCategoriseSlide />
  </section>
</template>

<script>
import SlideTitleSettingsV2 from '@/components-v2/presentation-editor/side-right/SlideTitleSettingsV2.vue'
import Settings from '@/components-v2/presentation-editor/side-right/RightColumnQuizSettings.vue'
import CategoryInput from './CategoryInput.vue'

export default {
  name: 'CategoriseConfigView',
  components: {
    SlideTitleSettingsV2,
    Settings,
    CategoryInput,
  },
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryColorMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryBackgroundColorMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryAnnotationMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    onAddCategories: {
      type: Function,
      default: () => {},
    },
    onRemoveCategories: {
      type: Function,
      default: () => {},
    },
    onUpdateCategories: {
      type: Function,
      default: () => {},
    },
    maxCategories: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    isMaxItems() {
      return this.categories.length >= this.maxCategories
    },
    removable() {
      return this.categories.length > 2
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    addCategory() {
      this.onAddCategories({
        id: window.crypto.randomUUID(),
        value: '',
        options: [],
      })
    },
    removeCategory(id) {
      this.onRemoveCategories(id)
    },
    updateCategory(updatedCategory) {
      this.onUpdateCategories(updatedCategory)
    },
  },
}

</script>

<style lang="scss" scoped>
.category-config {
  & > .category-options-section {
    & > .category-options {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
}
</style>
